module.exports = __webpack_public_path__ + "img/icon_primary_menu_locations@2x.3aeeef16.png";